import { AsyncPipe } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { UserDataFacade } from '@ra-state';
import {
  BreadcrumbComponent,
  BreadcrumbConfig,
  IBreadcrumbConfig,
  IBreadcrumbItem,
} from '@ra-web-tech-ui-toolkit/components';
import { BreadcrumbService } from '@servicesV2/breadcrumb.service';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-navigation',
  styleUrls: ['./navigation.component.scss'],
  templateUrl: './navigation.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [BreadcrumbComponent, AsyncPipe],
})
export class NavigationComponent {
  private readonly router = inject(Router);
  private readonly userDataFacade = inject(UserDataFacade);
  private readonly breadcrumbService = inject(BreadcrumbService);

  currentCustomProvisioningData$ = this.userDataFacade.currentCustomProvisioningData$;
  breadcrumbs$: Observable<IBreadcrumbItem[]> = this.breadcrumbService.breadcrumbs$.pipe(
    tap((data) => {
      this.breadcrumbConfig = new BreadcrumbConfig({
        ...this.breadcrumbConfig,
        hideTitle: Array.isArray(data[1]?.children) && data[1]?.children.length > 0,
      });
    }),
  );
  title$: Observable<string> = this.breadcrumbService.title$;
  breadcrumbConfig: IBreadcrumbConfig = {
    emptyText: '',
    hideTitle: false,
  };

  navigateSignal$ = toObservable(this.breadcrumbService.$navigateSignal).pipe(
    tap((path) => {
      if (path) {
        this.router.navigate([path]);
      }
    }),
  );

  onClicked($event: IBreadcrumbItem): void {
    // Reset the signal previous value before setting a new one
    this.breadcrumbService.$navigateSignal.set(null);
    // Notify the breadcrumb service about the clicked breadcrumb
    this.breadcrumbService.onClicked($event);
  }
}
